import mailIcon from '../mail.png';
import linkedinIcon from '../linkedin.jpeg';
import me from '../profile.jpeg';

function Headings() {
  return (
    <div className="hero-container">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">Jessy Wang</h1>
          <h2 className="hero-subtitle">Data Scientist & Analytics Leader</h2>
          <p className="hero-description">
            Transforming complex data into actionable business insights.
            Specializing in BI, Machine Learning, and Cloud Platforms.
          </p>
          
          <div className="hero-buttons">
            <a href="mailto:jeswang421@gmail.com" className="hero-btn primary">
              <img src={mailIcon} alt="Email" className="btn-icon" />
              Email Me
            </a>
            <a href="https://www.linkedin.com/in/tzuying-wang/" className="hero-btn secondary">
              <img src={linkedinIcon} alt="LinkedIn" className="btn-icon" />
              LinkedIn
            </a>
          </div>
        </div>
        
        <div className="hero-image-container">
          <img src={me} className="hero-profile-img" alt="Jessy Wang" />
          <div className="hero-blob"></div>
        </div>
      </div>
    </div>
  );
}

export default Headings;
